import { useNavigate } from 'react-router-dom';

export default function DonatePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top bar */}
      <div className="bg-white border-b border-gray-100 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-500 hover:text-teal-600 transition-colors cursor-pointer text-sm"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </button>
          <div className="h-5 w-px bg-gray-200"></div>
          <div className="flex items-center gap-2">
            <div className="bg-white p-1 rounded-lg border border-gray-200/50 shadow-sm flex items-center justify-center">
              <img
                src="/logo/logo.jpg"
                alt="Bettako USA"
                className="h-8 md:h-10 w-auto object-contain"
              />
            </div>
            <span className="font-semibold text-gray-800 text-sm">Bettako USA Community Support Services</span>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-2xl w-full">

          {/* Header */}
          <div className="text-center mb-10">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-5">
              <i className="ri-heart-add-line text-3xl text-teal-600"></i>
            </div>
            <h1
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Make a Donation
            </h1>
            <p className="text-lg text-gray-600 max-w-lg mx-auto leading-relaxed">
              Your generosity directly funds life-changing support services for individuals and families in need across the United States.
            </p>
          </div>

          {/* Donation card */}
          <div className="bg-white rounded-3xl border border-gray-100 overflow-hidden">

            {/* Impact banner */}
            <div className="bg-teal-600 px-8 py-5 text-white text-center">
              <p className="text-sm font-medium text-teal-100 mb-1">Every dollar makes a difference</p>
              <p className="text-lg font-semibold">100% of your donation goes directly to community support services</p>
            </div>

            <div className="p-8 md:p-10">
              {/* JustGiving info */}
              <div className="flex flex-col items-center text-center mb-8">
                <img
                  src="https://storage.readdy-site.link/project_files/f59951a5-0bf2-48fa-869d-e5f51df65b96/6f96602d-124c-4e78-8ffd-4800adeb3db0_just-giving-with-cc.png?v=fd5848f7d9d1db095be59730a47ce25b"
                  alt="JustGiving - accepted payment methods"
                  className="h-14 object-contain mb-5"
                />
                <p className="text-gray-600 leading-relaxed max-w-md">
                  <strong>JustGiving.org</strong> is a nonprofit organization whose mission is to increase charitable giving by connecting people with the causes they care about most.
                </p>
              </div>

              {/* Divider */}
              <div className="flex items-center gap-4 mb-8">
                <div className="flex-1 h-px bg-gray-100"></div>
                <span className="text-xs text-gray-400 uppercase tracking-wider font-medium">Secure Donation</span>
                <div className="flex-1 h-px bg-gray-100"></div>
              </div>

              {/* Trust badges */}
              <div className="grid grid-cols-3 gap-4 mb-8">
                {[
                  { icon: 'ri-shield-check-line', label: 'Secure & Safe', color: 'text-teal-600' },
                  { icon: 'ri-percent-line', label: '100% to Charity', color: 'text-orange-500' },
                  { icon: 'ri-receipt-line', label: 'Tax Deductible', color: 'text-teal-600' },
                ].map((badge, i) => (
                  <div key={i} className="flex flex-col items-center gap-2 p-4 bg-gray-50 rounded-xl">
                    <div className={`w-8 h-8 flex items-center justify-center`}>
                      <i className={`${badge.icon} text-xl ${badge.color}`}></i>
                    </div>
                    <span className="text-xs font-semibold text-gray-700 text-center">{badge.label}</span>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
              <a
                href="https://www.justgiving.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full py-5 bg-teal-600 hover:bg-teal-700 text-white font-bold rounded-2xl transition-colors cursor-pointer text-lg whitespace-nowrap"
              >
                <i className="ri-heart-fill text-xl"></i>
                Donate with JustGiving
                <i className="ri-external-link-line text-base opacity-70"></i>
              </a>

              <p className="text-center text-xs text-gray-400 mt-4">
                You will be redirected to JustGiving.org to complete your donation securely.
              </p>
            </div>
          </div>

          {/* Bottom note */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Questions about donating?{' '}
              <button
                onClick={() => navigate('/#contact')}
                className="text-teal-600 hover:underline cursor-pointer font-medium"
              >
                Contact us
              </button>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
